import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/detail/news/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 sm:gap-5 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
    >
      <div className="w-full sm:w-44 h-44 sm:h-28 flex-shrink-0 overflow-hidden rounded-md bg-background-100">
        <img
          src={item.thumbnail}
          alt={`${item.title} 配图`}
          title={`${item.title} 小仓优子最新新闻`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-center gap-2 text-xs mb-2">
          <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">{item.category}</span>
          <span className="text-foreground-500">{item.date}</span>
        </div>
        <h4 className="font-heading text-base text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-2">
          {item.title}
        </h4>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 hidden sm:block">{item.summary}</p>
        <span className="mt-3 sm:mt-auto text-xs text-foreground-400 flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {item.views.toLocaleString()} 阅读
        </span>
      </div>
    </Link>
  );
}